import React from 'react';

type Props = {
  page: number;
  pages: number;
  total: number;
  onPageChange: (page: number) => void;
};

export default function Pagination({ page, pages, total, onPageChange }: Props) {
  if (pages <= 1) return null;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 0',
      fontSize: '13px',
      color: 'var(--gray-500)',
    }}>
      <span>
        Page {page} of {pages} ({total.toLocaleString()} total)
      </span>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          className="btn btn-secondary btn-sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </button>
        <button
          className="btn btn-secondary btn-sm"
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
